import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import { Iconify, MenuPopover, NextImage } from '@sdf/base';
import { Styles } from '@t2c/shared-fe';
import React, { useState } from 'react';

interface Props {
  anchorEl: null | HTMLElement;
  setAnchorEl: (_: null | HTMLElement) => void;
  menuOptions: {
    id: string;
    label: string;
    isHidden?: boolean;
    iconifyIcon: string;
    onClick: () => void;
  }[];
}

export const DropDownOptions: React.FC<Props> = ({ anchorEl, setAnchorEl, menuOptions }) => {
  const open = Boolean(anchorEl);

  const handleMenuListClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuListClose = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        borderRadius: '50%',
        padding: '2px',
        marginRight: '10px'
      }}
      onClick={handleMenuListClick}
    >
      <MenuPopover
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuListClose}
        disabledArrow
        sx={styles.menu}
      >
        {menuOptions?.map(({ id, label, onClick, iconifyIcon, isHidden }) => {
          if (!isHidden) {
            return (
              <MenuItem
                key={id}
                onClick={(event) => {
                  event.stopPropagation();
                  onClick();
                }}
                sx={styles.menuItemStyle}
              >
                {/* <NextImage src={icon} alt="Logo" width={12} height={12} sx={styles.menuIcons} /> */}
                <Iconify icon={iconifyIcon} sx={styles.menuIcons} />
                {label}
              </MenuItem>
            );
          }
        })}
      </MenuPopover>
      <Iconify icon="solar:menu-dots-bold" fontSize={'22px'} color={theme.palette.text.primary} />
    </Box>
  );
};

const styles: Styles = {
  menu: {
    maxWidth: '147px',
    borderRadius: '8px',
    padding: 0,
    overflow: 'hidden',
    backgroundColor: (theme) => theme.palette.background.primary,
  },
  menuItemStyle: {
    color: (theme) => theme.palette.text.primary,
    fontSize: '12px',
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 0,
    padding: 1,
    width: '100%',
    '&:hover': {
      backgroundColor: (theme) => theme.palette.background.activeCard,
    },
  },

  menuIcons: {
    height: 12,
    width: 12,
    marginRight: '6px',
  },
};
